import React, { useState } from 'react';
import { Lock, User, KeyRound } from 'lucide-react';
import {
  loginUser,
  loginWith2FA,
  setAuthToken,
} from '../services/api';

const AuthGate = ({ onAuthenticated }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [pendingUserId, setPendingUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const resetError = () => setError('');

  const completeAuth = (payload) => {
    setAuthToken(payload.token);
    onAuthenticated(payload.user);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    resetError();
    setLoading(true);
    try {
      const data = await loginUser(username.trim(), password);
      if (data.requiresTwoFactor) {
        setPendingUserId(data.userId);
        setOtp('');
      } else {
        completeAuth(data);
      }
    } catch (err) {
      setError(err.error || 'Login fallito');
    } finally {
      setLoading(false);
    }
  };

  const handle2FA = async (e) => {
    e.preventDefault();
    resetError();
    setLoading(true);
    try {
      const data = await loginWith2FA(pendingUserId, otp.trim());
      completeAuth(data);
    } catch (err) {
      setError(err.error || 'Codice 2FA non valido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0F171A] to-[#1A2E35] text-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#0A1012]/80 border border-slate-700 shadow-2xl backdrop-blur-sm p-6 rounded-sm">
        <div className="mb-6">
          <h1 className="text-sm font-bold tracking-[0.2em]">KOZENI</h1>
          <p className="text-[11px] text-slate-400 mt-1">Accesso richiesto</p>
        </div>

        {!!error && (
          <div className="mb-4 border border-red-500/40 bg-red-500/10 text-red-300 text-xs p-3 rounded-sm">
            {error}
          </div>
        )}

        {pendingUserId ? (
          <form onSubmit={handle2FA} className="space-y-4">
            <label className="block">
              <span className="text-[10px] tracking-widest text-slate-400 uppercase">Codice 2FA</span>
              <div className="mt-2 flex items-center gap-2 bg-[#162125] border border-slate-700 px-3 py-2 rounded-sm">
                <KeyRound size={14} className="text-slate-500" />
                <input
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="000000"
                  inputMode="numeric"
                  className="w-full bg-transparent outline-none text-sm"
                  required
                />
              </div>
            </label>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 bg-[#2D6A4F] hover:bg-[#3D7A5F] disabled:opacity-50 text-white text-xs tracking-widest uppercase"
            >
              {loading ? 'Verifica...' : 'Verifica 2FA'}
            </button>
            <button
              type="button"
              onClick={() => setPendingUserId(null)}
              className="w-full py-2 border border-slate-700 text-xs tracking-widest uppercase"
            >
              Torna al login
            </button>
          </form>
        ) : (
          <form onSubmit={handleLogin} className="space-y-4">
            <label className="block">
              <span className="text-[10px] tracking-widest text-slate-400 uppercase">Username</span>
              <div className="mt-2 flex items-center gap-2 bg-[#162125] border border-slate-700 px-3 py-2 rounded-sm">
                <User size={14} className="text-slate-500" />
                <input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full bg-transparent outline-none text-sm"
                  required
                />
              </div>
            </label>

            <label className="block">
              <span className="text-[10px] tracking-widest text-slate-400 uppercase">Password</span>
              <div className="mt-2 flex items-center gap-2 bg-[#162125] border border-slate-700 px-3 py-2 rounded-sm">
                <Lock size={14} className="text-slate-500" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-transparent outline-none text-sm"
                  required
                />
              </div>
            </label>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 bg-[#2D6A4F] hover:bg-[#3D7A5F] disabled:opacity-50 text-white text-xs tracking-widest uppercase"
            >
              {loading ? 'Attendere...' : 'Accedi'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AuthGate;
